import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestCategoryListAction } from 'redux/actions/type';
import { REQUEST_CATEGORY_LIST } from 'redux/actions/types';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import {
  requestCategoryListFailure,
  requestCategoryListSuccess,
  throwError,
} from 'redux/actions/actions';
import CategoryVO from 'commons/vo/CategoryVO';
import { AxiosResponse } from 'axios';

function* requestCategoryListSaga(action: RequestCategoryListAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.CATEGORY);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: CategoryVO[] = keyFlowResponse.getResult(CategoryVO) as CategoryVO[];
    yield put(requestCategoryListSuccess({ categoryList: resultList }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestCategoryListFailure());
  }
}

export function* watchCategorySaga() {
  yield takeEvery(REQUEST_CATEGORY_LIST, requestCategoryListSaga);
}
